<template>
    <div class="el-main">
        <el-row :gutter="20">
            <el-col :span="8">
                <el-card shadow="hover" class="mgb20" style="height:252px;">
                    <div class="user-info">
                        <img src="@/assets/img/img.jpg" class="user-avator" alt />
                        <div class="user-info-cont">
                            <div class="user-info-name">{{user.realname}}</div>
                            <div>{{user.role}}</div>
                        </div>
                    </div>
                    <div class="user-info-list">
                        手机号：
                        <span>{{user.mobile}}</span>
                    </div>
                    <div class="user-info-list">
                        坐席：
                        <span>{{user.mobile_sys_id}}</span>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="16" v-if="false">
                <el-row :gutter="20" class="mgbt20">
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-1">
                                <i class="el-icon-lx-people grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">1234</div>
                                    <div>呼叫总数</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-2">
                                <i class="el-icon-lx-notice grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">321</div>
                                    <div>接通数量</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-3">
                                <i class="el-icon-lx-goods grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">5000</div>
                                    <div>呼叫总时长</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-1">
                                <i class="el-icon-lx-people grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">1234</div>
                                    <div>订单总数</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-2">
                                <i class="el-icon-lx-notice grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">321</div>
                                    <div>接通数量</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-3">
                                <i class="el-icon-lx-goods grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">5000</div>
                                    <div>呼叫总时长</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row class="dashboard" v-if="Object.keys(dashboardKeys).length>0">
            <div class="dashboardItem" v-if="dashboardKeys.includes('wash')">
                <wash-data ref="wastData" :initWashData="washTableData"></wash-data>
            </div>
            <div class="dashboardItem" v-if="dashboardKeys.includes('recommend')">
                <recommend-data ref="recommendData" :initRecommendData="recomdTableData"></recommend-data>
            </div>
        </el-row>

    </div>
</template>

<script>
import washData from "./module/wash.vue";
import recommendData from "./module/recommend.vue";
import * as api from '@/api/module'
export default {
    name: 'dashboard',
    components: {
        washData,
        recommendData,
    },
    watch: {
        getTableData: {
            handler(val) {
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        range() {
            //  return this.$parent.$refs.wastData.range// this 指向的是Vue实例
        }
    },
    data() {
        return {
            cleardaterange: "",
            recommenddaterange: '',
            user: {},
            washTableData: [],
            recomdTableData: [],
            dashboardKeys: [],
        };
    },

    created() {
        let userString = localStorage.getItem('user');
        this.user = JSON.parse(userString);
        this.getTableData()

    },

    methods: {
        getTableData() {
            let _this = this;
            api.dashboard(_this.query)
                .then(res => {
                    if (res.code == 200) {
                        let data = res.data;
                        _this.dashboardKeys = Object.keys(data);
                        if (res.data.wash) {
                            this.washTableData = res.data.wash;
                        }
                        if (res.data.recommend) {
                            this.recomdTableData = res.data.recommend;
                        }

                    } else {
                        this.$message.error(res.msg);
                        return;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }

    }
};
</script>

<style lang="less" scoped>
.box-card {
    margin: 8px 0;
    margin-right: 8px;
    .card-title {
        position: relative;
        font-size: 14px;
        color: #000;
        border-radius: 1px;
        padding-left: 10px;
        margin-right: 10px;
        line-height: 32px;
    }
    .card-title::before {
        position: absolute;
        height: 12px;
        content: ' ';
        left: 0;
        top: 50%;
        bottom: 50%;
        transform: translateY(-50%);
        border-left: 3px solid #009cff;
    }
}
.dashboard {
    display: flex;
    align-content: center;
    flex-wrap: wrap-reverse; //换行
    align-content: flex-start; //紧揍排列
    justify-content: center;
    .dashboardItem {
        outline-offset: -1px;
        flex: none;
        width: 50%;
        &:only-child {
            width: 100%;
        }
        &:nth-child(2n) {
            // 去除第2n个的margin-right
            margin-right: 0;
        }
        &:first-child:nth-last-child(2n + 1) {
            width: 100%;
            margin-right: 0;
        }
    }
}
.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.grid-num {
    font-size: 30px;
    font-weight: bold;
}

.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
}

.user-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
}

.user-avator {
    width: 120px;
    height: 120px;
    border-radius: 50%;
}

.user-info-cont {
    padding-left: 50px;
    flex: 1;
    font-size: 14px;
    color: #999;
}

.user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
}

.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}

.user-info-list span {
    margin-left: 70px;
}

.mgb20 {
    margin-bottom: 20px;
}
.mgbt20 {
    margin-bottom: 40px;
}
.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 300px;
}
</style>
